import { Box, Button, Chip, Grid, InputLabel, Tooltip } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AccordianContainer from "../../CustomComponents/AccordianContainer";
import CustomAutoComplete from "../../CustomComponents/CustomAutoComplete";
import CustomDataGrid from "../../CustomComponents/CustomDataGrid";
import CustomDateField from "../../CustomComponents/CustomDateField";
import { useRef } from "react";
import { CommonShortCutAction } from "../../Store/CommonShortCutsReducer";

const ReceiptDetails = () => {
  const filterScreen = useSelector((state) => state.cov.filterScreen);
  //Flag used to show/Hide detail screen
  const [detailScreenView, setDetailScreenView] = useState(false);
  const [receiptType, setReceiptType] = useState([
    "EMI Receipt",
    "Penal Receipt",
    "Pre Payment Receipt",
    "Other Receipts",
  ]);
  const [appNum, setAppNum] = useState();
  const [fieldSelection, setFieldSelection] = useState(null);
  const [activeFilterArray, setActiveFilterArray] = useState([]);
  const [receiptValue, setReceiptValues] = useState([]);
  const [receiptDate, setReceiptDate] = useState(null);

  const [rows, setRows] = useState([]);

  const dispatch = useDispatch();
  //shortcut key
  const clearRef = useRef(null);
  const searchButtonRef = useRef(null);

  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "receiptDetails",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    let refList = { clearRef: clearRef, searchButtonRef: searchButtonRef };
    let charCode = String.fromCharCode(event.which).toLowerCase();
    let date = new Date();
    if (event.ctrlKey) {
      if (charCode === "i") {
        setReceiptDate(date);
      } else if (charCode === "o") {
        date.setDate(date.getDate() + 1);
        setReceiptDate(date);
      } else if (charCode === "p") {
        date.setDate(date.getDate() - 1);
        setReceiptDate(date);
      } else {
        dispatch(
          CommonShortCutAction.getShortCutValue({
            event: event,
            refs: refList,
            screen: "receiptDetails",
          })
        );
      }
    }
  };

  //Data Grid storage
  const [pageSize, setPageSize] = useState();

  //Methods
  const ClearButtonHandler = () => {
    setReceiptDate(null);
    setDetailScreenView(false);
    setActiveFilterArray([]);
    setFieldSelection(null);
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  const getData = async (appNum) => {
    setDetailScreenView(true);
    try {
      const response = await axios.post(
        "/customerOneView/getReceiptDetailData",
        {
          applicationNum: appNum,
          receiptDate: receiptDate,
          receiptType: activeFilterArray,
        }
      );
      const responseWithKey = response.data.map((record, index) => {
        return {
          ...record,
          id: index,
          creditAmount: record.creditAmount.toLocaleString("en-US"),
          debitAmount: record.debitAmount.toLocaleString("en-US"),
          receiptDate: new Date(record.receiptDate).toLocaleDateString("fr-FR"),
          referenceDate: new Date(record.referenceDate).toLocaleDateString(
            "fr-FR"
          ),
        };
      });
      setRows(responseWithKey);
    } catch {}
  };

  const searchButtonClickHandler = () => {
    getData(appNum);
  };
  useEffect(() => {
    const appNum = localStorage.getItem("appNum");
    setAppNum(appNum);
    getData(appNum);
  }, [appNum]);
  const columnsData = [
    {
      field: "receiptType",
      headerName: "Receipt Type",
      headerAlign: "center",
      flex: 147,
      align: "left",
    },
    {
      field: "voucherNumber",
      headerName: "Voucher Number",
      headerAlign: "center",
      flex: 147,
      align: "left",
    },
    {
      field: "receiptDate",
      headerName: "Receipt Date",
      headerAlign: "center",
      flex: 147,
      align: "left",
    },
    {
      field: "glAcc",
      headerName: "GL Account",
      headerAlign: "center",
      flex: 147,
      align: "left",
    },
    {
      field: "glAccDes",
      headerName: "GL Account Description",
      headerAlign: "center",
      flex: 167,
      align: "left",
    },

    {
      field: "debitAmount",
      headerName: "Debit Amount",
      headerAlign: "center",
      flex: 147,
      align: "left",
    },
    {
      field: "creditAmount",
      headerName: "Credit Amount",
      headerAlign: "center",
      flex: 125,
      align: "left",
    },

    {
      field: "referenceNumber",
      headerName: "Reference Number",
      headerAlign: "center",
      flex: 147,
      align: "left",
    },
    {
      field: "utrNumber",
      headerName: "UTR No",
      headerAlign: "center",
      flex: 147,
      align: "left",
    },
    {
      field: "referenceDate",
      headerName: "Reference Date",
      headerAlign: "center",
      flex: 147,
      align: "left",
    },
    {
      field: "remarks",
      headerName: "Remarks",
      headerAlign: "center",
      flex: 147,
      align: "left",
    },
  ];
  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setReceiptValues(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };
  const onRemoveFieldClick = (value) => {
    const currentIndex = activeFilterArray.findIndex(
      (record) => record === value
    );
    const duplicate = [...activeFilterArray];
    duplicate.splice(currentIndex, 1);
    setActiveFilterArray([...duplicate]);
  };
  return (
    <>
      <Box>
        <AccordianContainer
          title="Receipt Filter"
          initialOpen={true}
          sx={{
            border: "2px solid #1976d2",
          }}
        >
          <Box sx={{ marginTop: "-1%" }}>
            <Grid
              container
              rowSpacing={2}
              columnSpacing={3}
              sx={{ alignItems: "center" }}
            >
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomDateField
                  variant="standard"
                  label="Receipt Date"
                  value={receiptDate}
                  onChange={(value) => {
                    setReceiptDate(value);
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomAutoComplete
                  variant="standard"
                  type="text"
                  placeholder="Select Receipt Filter Selection"
                  label="Receipt Filter Selection"
                  required={false}
                  value={fieldSelection}
                  autoCompleteValues={receiptType}
                  onChange={(event, value) => {
                    if (value != "" && value != null) {
                      setFieldSelection(value);
                      let updatedFilterArray = [...activeFilterArray];
                      updatedFilterArray.push(value);
                      setActiveFilterArray([
                        ...new Set([...updatedFilterArray]),
                      ]);
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={6} xl={6}>
                <Box>
                  <Box>
                    <InputLabel
                      size="small"
                      sx={{
                        color: "#004A92",
                        mb: 2,
                        fontWeight: 400,
                        fontSize: "14px",
                      }}
                    >
                      Active Filters
                    </InputLabel>
                  </Box>
                  <Box>
                    {activeFilterArray.map((row, index) => (
                      <Chip
                        label={row}
                        variant={"contained"}
                        color="primary"
                        onDelete={() => {
                          onRemoveFieldClick(row);
                        }}
                        sx={{ marginTop: "2px", marginLeft: "2px" }}
                      />
                    ))}
                  </Box>
                </Box>
              </Grid>
            </Grid>

            <Box sx={{ marginTop: "8px" }}></Box>
            <Box
              sx={{
                marginTop: "8px",
                marginBottom: "4px",
                display: "flex",
                gap: "8px",
                justifyContent: "center",
              }}
            >
              <Tooltip title="Ctrl+F" placement="top">
                <Button
                  variant="contained"
                  type="submit"
                  sx={{ height: "2rem", fontWeight: "bold" }}
                  onClick={searchButtonClickHandler}
                  ref={searchButtonRef}
                >
                  Search
                </Button>
              </Tooltip>
              <Tooltip title="Ctrl+D" placement="top">
                <Button
                  sx={{
                    color: "white",
                    backgroundColor: "black",
                    height: "2rem",
                    fontWeight: "bold",
                  }}
                  onMouseOver={({ target }) => {
                    target.style.backgroundColor = "black";
                    target.style.color = "white";
                  }}
                  variant="contained"
                  onClick={ClearButtonHandler}
                  ref={clearRef}
                >
                  Clear
                </Button>
              </Tooltip>
            </Box>
          </Box>
        </AccordianContainer>
        {detailScreenView && (
          <Box>
            <CustomDataGrid
              noDataMessage="No Data."
              noDataOnFilterMessage="No Data on Applied Filter."
              rows={rows}
              onPageSizeChange={(pageSize) => {
                setPageSize(pageSize);
              }}
              columns={columnsData}
              pageSize={10}
              pageSizeOptions={[]}
              gridLazyLoad={() => {}}
              onSortModelChange={() => {}}
            />
          </Box>
        )}
      </Box>
    </>
  );
};
export default ReceiptDetails;
